class Step extends HTMLElement{
    constructor(){
        super()
        this.productsInput = this.querySelectorAll('input[name="step_product"]')
        this.stepLink = this.querySelector('.step--link')
        this.stepCounter = document.querySelector('step-counter')
        this.button = document.querySelector('.header__custom-button .button-component')
        this.template = this.dataset.template
        this.cartSymbol = JSON.parse(this.querySelector('#cartInfo').textContent)
        this.preSelectedCase = this.querySelector('.step--link');

      

        if(this.template == 'step_1'){
            this.productsInput.forEach((input)=>{
                this.handleCase(input)
                input.addEventListener('change',this.handleCase.bind(this, input))
            })

            this.preSelectedCase.addEventListener('click', (e) => {
                console.log(this.preSelectedCase)
                const inputProductData = {
                    quantity: 1,
                    images: {
                        step_2: {
                            desktop: this.preSelectedCase.getAttribute('data-image'),
                            tablet: this.preSelectedCase.getAttribute('data-image'),
                            mobile: this.preSelectedCase.getAttribute('data-image')
                        },
                        step_4: {
                            desktop: this.preSelectedCase.getAttribute('data-image'),
                            tablet: this.preSelectedCase.getAttribute('data-image'),
                            mobile: this.preSelectedCase.getAttribute('data-image')
                        }
                    }
                }
                localStorage.setItem('selectedCase', JSON.stringify(inputProductData))
            })
        }

        // this.selectedQuantityText = this.querySelector('#selectedQuantity')
        // this.selectedLeftText = this.querySelector('#selectedLeft')
        this.quantitySelectors = this.querySelectorAll('quantity-input')
        this.addOnsItems = this.querySelectorAll('.step--product-item')
        this.susbscriptionOptions = this.querySelectorAll('input[name="subscription"]')
        this.planOptions = this.querySelector('select[name="selling_plan"]')

        if(this.template == 'step_3'){this.handleScents()}
        if(this.template == 'step_2'){this.handleSuscriptionPlan()}        
        if(this.template == 'step_4' || this.template == 'step_5'){this.handleAddOnsOrTravelBag(this.template)}

        if(this.template == 'step_4'){
            this.addOnsItems.forEach((item, index)=>{
                var lastCheckedForThatItem = localStorage.getItem(`lastCheckedAddsOnProduct-${index}`)
                if (lastCheckedForThatItem) {
                    item.setAttribute('data-last-checked', lastCheckedForThatItem)
                }
            })
            var currentCombinations = this.closest('.step').getCombination()
            if(currentCombinations.combinationFormat) this.setImagesCombination(currentCombinations.combination) 
        }
    }
    // STEP 1
    handleCase(input){
        if(input.checked){
            const inputProductData = {
                id:input.value,
                quantity: 1,
                name: input.getAttribute('data-name'),
                images: {
                    step_2: {
                        desktop: input.getAttribute('data-step2-image-desk'),
                        tablet: input.getAttribute('data-step2-image-tablet'),
                        mobile: input.getAttribute('data-step2-image-mobile')
                    },
                    step_4: {
                        desktop: input.getAttribute('data-step4-image-desk'),
                        tablet: input.getAttribute('data-step4-image-tablet'),
                        mobile: input.getAttribute('data-step4-image-mobile')
                    }
                }
            }
            localStorage.setItem('selectedCase', JSON.stringify(inputProductData))
            this.enableButton()
        }
        let selectedCaseID = JSON.parse(localStorage.getItem('selectedCase')) || null
        let inputProductID = input.value || null
        if(selectedCaseID != null && inputProductID != null){
            if(selectedCaseID.id == inputProductID){
                input.checked = true
                this.enableButton()
            }
        }
        
        
    }
    // STEP 2
    handleScents(){
        let $this = this
        let selectedPack = JSON.parse(localStorage.getItem('selectedPack'))
        let selectedPackQuantity = JSON.parse(localStorage.getItem('selectedPackQuantity'))
        let checkedSubscription = JSON.parse(localStorage.getItem('checkedSuscription'))
        let offerBar = document.querySelector('.step-scent__offer-block')
        let quantityObject = new Array()
        let quantityTotal = 0
        let selectedLeftText = this.selectedLeftText
        // let selectedQuantityText = this.selectedQuantityText
        let quantitySelectors = this.quantitySelectors
        let filteredQuantity = selectedPack?.filter(item=> item.quantity > 0)

        this.selectedQuantityText = this.querySelector('#selectedQuantity')
        this.selectedLeftText = this.querySelector('#selectedLeft')

        
        /*
            Start
            Initialize the Scent text
        */
        let minQty = parseInt(localStorage.getItem('minimumQty'))
        let selectedQty = parseInt(localStorage.getItem('selectedPackQuantity')) || 0
        let leftQty = minQty - selectedQty
        let textContainer = $this.querySelector('.step--text__scents.step--text')
        let textContainerContent = `
            <span id="selectedQuantity">${selectedQty}</span>/${minQty} Chosen - 
            Select <span id="selectedLeft">${leftQty}</span> more before proceeding
        `
        textContainer.innerHTML = textContainerContent
        /*
            END
            Initialize the Scent text
        */

        /* Show Offer bar and quantity left if susbscription was selected  */
        checkedSubscription && offerBar?.classList.remove('hidden')
        checkedSubscription && textContainer?.classList.remove('hidden')

        // Offer Block
        updateOfferBlock(selectedQty, minQty)

        selectedPackQuantity && (this.selectedQuantityText.textContent = selectedPackQuantity)
        // selectedPackQuantity && (this.selectedLeftText.textContent = minQty - selectedPackQuantity)

        if (selectedPackQuantity) {
            if (leftQty > 0) {
                document.querySelector('#selectedLeft').textContent = minQty - quantityTotal
            }else{
                document.querySelector('#selectedLeft').textContent = 0
            }
        }

        this.quantitySelectors.forEach((quantity)=>{
            let prodId = quantity.dataset.prodId
            let prodValue = 0
            quantitySelectors.forEach(item=>{
                if(selectedPackQuantity >= minQty){
                    // item.querySelector('button[name="plus"]').setAttribute('disabled', 'disabled')
                    item.querySelector('button[name="minus"]').classList.remove('disabled')
                    this.enableButton()
                }else{
                    // item.querySelector('button[name="plus"]').removeAttribute('disabled')
                    this.disableButton()
                } 
            });  
            filteredQuantity?.map(storageQt=>{
                if(storageQt.id == prodId ){
                    quantity.querySelector('input').value = storageQt.quantity
                    prodValue =  storageQt.quantity
                }
            })
            
            let prodObject ={id : prodId, quantity: prodValue}
            quantityObject.push(prodObject)
            quantity.addEventListener('change',function(){
                prodValue = quantity.querySelector('input').value
                let modifiedQuantity = quantityObject.map(obj => {
                    if (obj.id === quantity.dataset.prodId) {
                        return { ...obj, quantity: prodValue };
                    }
                    return obj;
                });
            quantityObject = modifiedQuantity
            quantityTotal = quantityObject.reduce((total, item) => total + parseInt(item.quantity), 0);
            quantitySelectors.forEach(item=>{
                if(quantityTotal >= minQty){
                    // item.querySelector('button[name="plus"]').setAttribute('disabled', 'disabled')
                    $this.enableButton()
                }else{
                    // item.querySelector('button[name="plus"]').removeAttribute('disabled')
                    $this.disableButton()
                } 
            });  
            document.querySelector('#selectedQuantity').textContent = quantityTotal
            if (minQty - quantityTotal > 0) {
                document.querySelector('#selectedLeft').textContent = minQty - quantityTotal
            }else{
                document.querySelector('#selectedLeft').textContent = 0
            }

            // Offer Block
            updateOfferBlock(quantityTotal, minQty)

            localStorage.setItem('selectedPack', JSON.stringify(quantityObject))
            localStorage.setItem('selectedPackQuantity', quantityTotal)
            })

        })

        function updateOfferBlock(total, target){
            let offerBlock = document.querySelector('.step-scent__offer-block [data-progress]')
            let progressPercentage = (total / target) * 100.0
            if (progressPercentage >= 100) {
                offerBlock.style.width = `100%`
            }else{
                offerBlock.style.width = `${progressPercentage}%`
            }
        }
        
    }

    // STEP 3
    handleSuscriptionPlan(){
        this.enableButton()
        this.setCaseImage()
        let suscription = false
        let minimumQty = 1;
        let freqMinimumQty = this.planOptions.options[ this.planOptions.selectedIndex ].getAttribute('data-minimum-qty');
        var minQuantityToAdd = parseInt(freqMinimumQty)
        this.susbscriptionOptions.forEach(input=>{
            if(input.checked){
                if(input.value != 'subscribe'){
                    suscription = false
                    minimumQty = 1
                }else{
                    suscription = true
                    minimumQty = minQuantityToAdd
                }
            localStorage.setItem('checkedSuscription', suscription)
            localStorage.setItem('minimumQty', minimumQty)
            }
            input.addEventListener('change',function(){
                if(input.value != 'subscribe'){
                    suscription = false
                    minimumQty = 1
                }else{
                    suscription = true
                    minimumQty = minQuantityToAdd
                }
                localStorage.setItem('minimumQty', minimumQty)
                localStorage.setItem('checkedSuscription', suscription)
            })
        })
        localStorage.setItem('selectedSuscription', JSON.stringify(this.planOptions.value))
        this.planOptions.addEventListener('change',function(){
            localStorage.setItem('selectedSuscription', JSON.stringify(this.value))
            minimumQty = parseInt(this.options[ this.selectedIndex ].getAttribute('data-minimum-qty'))
            localStorage.setItem('minimumQty', minimumQty)
            handlingFrequencyInfo(minimumQty , this.options[ this.selectedIndex ])
        })

        function handlingFrequencyInfo(minimumQty, selectedIndex){
            var originalPrice = document.querySelector(`[data-subscription-original-price]`);
            var discountedPrice = document.querySelector(`[data-subscription-discounted-price]`);
            var subscriptionBadges = document.querySelectorAll('[data-subscription-badge]')
            
            if (minimumQty == 3) {
                var OriginalPriceValue = parseInt(originalPrice.getAttribute('data-months-value'))
                var discountedPriceValue = parseInt(discountedPrice.getAttribute('data-months-value'))
                var originalPriceFormated = Shopify.formatMoney(OriginalPriceValue, Shopify.money_format)
                var discountedPriceFormated = 'Free'
                var badgeValue = subscriptionBadges[0].getAttribute('data-months-value')
            }else{
                var OriginalPriceValue = parseInt(originalPrice.getAttribute('data-year-value'))
                var discountedPriceValue = parseInt(discountedPrice.getAttribute('data-year-value'))
                var originalPriceFormated = Shopify.formatMoney(OriginalPriceValue, Shopify.money_format)
                var discountedPriceFormated = Shopify.formatMoney(discountedPriceValue, Shopify.money_format)
                var badgeValue = subscriptionBadges[0].getAttribute('data-year-value')
            }
            
            originalPrice.innerText = originalPriceFormated
            discountedPrice.innerText = discountedPriceFormated
            subscriptionBadges.forEach((badge)=>{
                badge.innerText = badgeValue
            })
        }
    }
    // STEP 4 -- 5
    handleAddOnsOrTravelBag(template){
        this.enableButton()
        if(template == 'step_4') {
            this.setCaseImage()
        }
        let objStorage = 'selectedAddons'
        if(template == 'step_5') objStorage = 'selectedTravelBag'
        let getStorage = JSON.parse(localStorage.getItem(objStorage))
        let selectedCaseName = JSON.parse(localStorage.getItem('selectedCase')).name
        let variantObj = new Array()
        let symbol = this.cartSymbol
        let stepCounter = this.stepCounter
        let priceObj={}
        let stepImgs= document.querySelectorAll('.step_img')
        if(selectedCaseName){
            stepImgs.forEach(img=>{
                if(img.classList.contains(selectedCaseName)){
                   img.classList.remove('hidden')
                }
            })
        }else{
            stepImgs[0].classList.remove('hidden')
        }
        this.addOnsItems.forEach(item=>{
            const addOnInputs = item.querySelectorAll('input[name="prod-variant"]')
            const priceBtn = item.querySelector('.step--product-item--add-to-cart')
            let price = 0;
            priceObj[`price_${item.dataset.prod}`] = price
            const image = item.querySelector('.step--product-item__img--wrapper img');
            addOnInputs.forEach(input=>{
                variantObj = [ ...variantObj, {id: input.value, quantity: 0} ]
                if(getStorage != '' && getStorage != null ){
                    getStorage.map((storageItem)=>{
                        variantObj = getStorage
                        if(storageItem.id == input.value && storageItem.quantity == 1){
                         input.checked = true}
                        })
                }
                if(localStorage.getItem(`price_${item.dataset.prod}`) != '' && localStorage.getItem(`price_${item.dataset.prod}`) != null ){
                    price = parseInt(localStorage.getItem(`price_${item.dataset.prod}`))
                    priceBtn.textContent = ` + ${symbol}${(price /100 ).toFixed(2).replace('.', ',')}`
                }
                
                input.addEventListener('change',function(){
                    if(input.checked){
                        const itemFound = variantObj.find(item=> item.id == input.value)
                        itemFound.quantity = 1;
                        price += parseInt(input.dataset.price)
                        image.src = input.getAttribute('data-image')
                        input.closest('.step--product-item').setAttribute('data-last-checked', input.getAttribute('data-value'))
                        if(template == 'step_4'){
                            var productItemIndex = input.closest('.step--product-item').getAttribute('data-index')
                            localStorage.setItem(`lastCheckedAddsOnProduct-${productItemIndex}`, input.getAttribute('data-value'))
                        }

                        var stepProductItem = input.closest('.step--product-item')
                        var checkedItemsNumbers = stepProductItem.querySelectorAll(`[name="prod-variant"]:checked`).length
                        if (checkedItemsNumbers != 1) {
                            priceBtn.textContent = ` + ${symbol}${(price /100 ).toFixed(2).replace('.', ',')}`
                        }

                        localStorage.setItem(`price_${item.dataset.prod}`, price)
                        // Get Combinations
                        if(window.combinations){
                            var currentCombinations = this.closest('.step').getCombination()
                            if(currentCombinations.combinationFormat) this.closest('.step').setImagesCombination(currentCombinations.combination)   
                        }
                        
                    }else{
                        const itemFound = variantObj.find(item=> item.id == input.value)
                        itemFound.quantity = 0;
                        if (price == input.dataset.price) {
                            price = input.dataset.price
                            localStorage.removeItem(`price_${item.dataset.prod}`)
                            priceBtn.textContent = ` + ${symbol}${(price /100 ).toFixed(2).replace('.', ',')}`
                            price = 0
                        }else{
                            price = price - parseInt(input.dataset.price)
                            localStorage.setItem(`price_${item.dataset.prod}`, price)
                            priceBtn.textContent = ` + ${symbol}${(price /100 ).toFixed(2).replace('.', ',')}`
                        }
                        var checkedInputs = item.querySelectorAll(`.step--variant input:checked`)
                        var lastCheckedInput = checkedInputs[checkedInputs.length - 1]
                        if (lastCheckedInput) {
                            input.closest('.step--product-item').setAttribute('data-last-checked', lastCheckedInput.getAttribute('data-value'))
                            image.src = checkedInputs[checkedInputs.length - 1].getAttribute('data-image')
                        }
                        if(template == 'step_4'){
                            var productItemIndex = input.closest('.step--product-item').getAttribute('data-index')
                            if (lastCheckedInput) {
                                localStorage.setItem(`lastCheckedAddsOnProduct-${productItemIndex}`, lastCheckedInput.getAttribute('data-value'))
                            }else{
                                localStorage.setItem(`lastCheckedAddsOnProduct-${productItemIndex}`, input.getAttribute('data-value'))
                            }
                        }
                        // Get Combinations
                        if(window.combinations){
                           var currentCombinations = this.closest('.step').getCombination()
                            if(currentCombinations.combinationFormat) this.closest('.step').setImagesCombination(currentCombinations.combination)                             
                        }
                        
                    }
                    // priceBtn.textContent = ` + ${symbol}${(price /100 ).toFixed(2).replace('.', ',')}`
                    localStorage.setItem(objStorage, JSON.stringify(variantObj))
                })
            
            })
        })
        this.stepLink.addEventListener('click',function(){
            event.preventDefault()
            localStorage.removeItem(objStorage)
            setTimeout(function(){
                if(template == 'step_4'){
                    stepCounter.handleStep4()   
                }
                if(template == 'step_5'){
                    stepCounter.handleStep5()   
                }
                
            },500)
            
        })
    }

    enableButton(){
        this.button.classList.remove('step-disabled')
    }
    disableButton(){
        this.button.classList.add('step-disabled') 
    }
    setCaseImage(){
        /*
            This function will change the case Image in Step 4 
            depending on the selected case in the Step 1
        */
        let mobile_selectedCaseImageURL = JSON.parse(localStorage.getItem('selectedCase')).images[this.template]['mobile'].split('$rt:')[0]
        let mobile_selectedCaseImageRatio = JSON.parse(localStorage.getItem('selectedCase')).images[this.template]['mobile'].split('$rt:')[1]
        let tablet_selectedCaseImageURL = JSON.parse(localStorage.getItem('selectedCase')).images[this.template]['tablet'].split('$rt:')[0]
        let tablet_selectedCaseImageRatio = JSON.parse(localStorage.getItem('selectedCase')).images[this.template]['tablet'].split('$rt:')[1]
        let desk_selectedCaseImageURL = JSON.parse(localStorage.getItem('selectedCase')).images[this.template]['desktop'].split('$rt:')[0]
        let desk_selectedCaseImageRatio = JSON.parse(localStorage.getItem('selectedCase')).images[this.template]['desktop'].split('$rt:')[1]
        
        let page_images = this.querySelectorAll('.step_img')
        
        page_images.forEach((image) => {
            if (image.classList.contains('step_img--mobile')) {
                image.src = mobile_selectedCaseImageURL
                image.srcset = mobile_selectedCaseImageURL
                image.closest('.media').style.paddingBottom = mobile_selectedCaseImageRatio
            }else if(image.classList.contains('step_img--tablet')){
                image.src = tablet_selectedCaseImageURL
                image.srcset = tablet_selectedCaseImageURL
                image.closest('.media').style.paddingBottom = tablet_selectedCaseImageRatio;
            }else{
                image.src = desk_selectedCaseImageURL
                image.srcset = desk_selectedCaseImageURL
                image.closest('.media').style.paddingBottom = desk_selectedCaseImageRatio;
                // image.closest('.media').style.paddingBottom = '68%';
            }
        });
    }
    
    getCombination(){
        var selectedCase = JSON.parse(localStorage.getItem('selectedCase')).name
        var combination = `case-${selectedCase}`
        var combinationFormat = false
        var productItems = document.querySelectorAll('.step--product-item')
        productItems.forEach(product => {
            if (product.getAttribute('data-last-checked')) {
                var productTitle = product.getAttribute('data-combination-title')
                var productLastChecked = product.getAttribute('data-last-checked')
                if(productTitle && productLastChecked){
                    combinationFormat = true
                }
                combination = `${combination} ${productTitle}-${productLastChecked}`
            }
        });
        return {
                combination: combination, 
                combinationFormat:combinationFormat
            }
    }

    setImagesCombination(currentCombinations){
        let currentCombinationsTrimmed = currentCombinations.trim()
        let mobile_image_url = window.combinations[currentCombinationsTrimmed].mobile.split('$rt:')[0]
        let mobile_image_ratio = window.combinations[currentCombinationsTrimmed].mobile.split('$rt:')[1]

        let tablet_image_url = window.combinations[currentCombinationsTrimmed].tablet.split('$rt:')[0]
        let tablet_image_ratio = window.combinations[currentCombinationsTrimmed].tablet.split('$rt:')[1]

        let desktop_image_url = window.combinations[currentCombinationsTrimmed].desktop.split('$rt:')[0]
        let desktop_image_ratio = window.combinations[currentCombinationsTrimmed].desktop.split('$rt:')[1]

        let page_images = this.querySelectorAll('.step_img')
        
        page_images.forEach((image) => {
            if (image.classList.contains('step_img--mobile')) {
                image.src = mobile_image_url
                image.srcset = mobile_image_url
                image.closest('.media').style.paddingBottom = mobile_image_ratio
            }else if(image.classList.contains('step_img--tablet')){
                image.src = tablet_image_url
                image.srcset = tablet_image_url
                image.closest('.media').style.paddingBottom = tablet_image_ratio;
            }else{
                image.src = desktop_image_url
                image.srcset = desktop_image_url
                image.closest('.media').style.paddingBottom = desktop_image_ratio;
                // image.closest('.media').style.paddingBottom = '68%';
            }
        });
    }
}

customElements.define('step-element', Step)